import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import {MenuContext as $9f4d05c8f96993f7$export$c7e742effb1c51e2} from "./context.mjs";
import {Popover as $3a473e3b7032f626$export$5b6b19405a83ff9d} from "../overlays/Popover.mjs";
import {SlotProvider as $62024859ff9f1f8a$export$8107b24b91795686} from "../utils/Slots.mjs";
import "../menu_vars.css";
import $3VWNT$menu_vars_cssmjs from "../menu_vars_css.mjs";
import {Tray as $9fca089dca5508dc$export$4589ed81930b555c} from "../overlays/Tray.mjs";
import {unwrapDOMRef as $3c2c983d5210446c$export$c7e28c72a4823176, useDOMRef as $3c2c983d5210446c$export$c2c55ef9111cafd8} from "../utils/useDOMRef.mjs";
import {useIsMobileDevice as $f357d4aae54bf1ff$export$736bf165441b18c7} from "../utils/useIsMobileDevice.mjs";
import {useMenuTriggerState as $3VWNT$useMenuTriggerState} from "react-stately/useMenuTriggerState";
import {PressResponder as $3VWNT$PressResponder} from "react-aria/private/interactions/PressResponder";
import $3VWNT$react, {forwardRef as $3VWNT$forwardRef, useRef as $3VWNT$useRef, Fragment as $3VWNT$Fragment} from "react";
import {useInteractOutside as $3VWNT$useInteractOutside} from "react-aria/useInteractOutside";
import {useMenuTrigger as $3VWNT$useMenuTrigger} from "react-aria/useMenu";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 












const $9928637078ff3033$export$27d2ad3c5815583e = /*#__PURE__*/ (0, $3VWNT$forwardRef)(function MenuTrigger(props, ref) {
    let triggerRef = (0, $3VWNT$useRef)(null);
    let domRef = (0, $3c2c983d5210446c$export$c2c55ef9111cafd8)(ref);
    let menuTriggerRef = domRef || triggerRef;
    let menuRef = (0, $3VWNT$useRef)(null);
    let { children: children, align: align = 'start', shouldFlip: shouldFlip = true, direction: direction = 'bottom', closeOnSelect: closeOnSelect, trigger: trigger = 'press' } = props;
    let [menuTrigger, menu] = (0, $3VWNT$react).Children.toArray(children);
    let state = (0, $3VWNT$useMenuTriggerState)(props);
    let { menuTriggerProps: menuTriggerProps, menuProps: menuProps } = (0, $3VWNT$useMenuTrigger)({
        trigger: trigger
    }, state, menuTriggerRef);
    let initialPlacement;
    switch(direction){
        case 'left':
        case 'right':
        case 'start':
        case 'end':
            initialPlacement = `${direction} ${align === 'end' ? 'bottom' : 'top'}`;
            break;
        case 'bottom':
        case 'top':
        default:
            initialPlacement = `${direction} ${align}`;
    }
    let isMobile = (0, $f357d4aae54bf1ff$export$736bf165441b18c7)();
    let menuContext = {
        ...menuProps,
        ref: menuRef,
        onClose: state.close,
        closeOnSelect: closeOnSelect,
        autoFocus: state.focusStrategy || true,
        UNSAFE_style: isMobile ? {
            width: '100%',
            maxHeight: 'inherit'
        } : undefined,
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($3VWNT$menu_vars_cssmjs))), {
            'spectrum-Menu-popover': !isMobile
        }),
        state: state
    };
    // Close when clicking outside the root menu when a submenu is open.
    let rootOverlayRef = (0, $3VWNT$useRef)(null);
    let rootOverlayDomRef = (0, $3c2c983d5210446c$export$c7e28c72a4823176)(rootOverlayRef);
    (0, $3VWNT$useInteractOutside)({
        ref: rootOverlayDomRef,
        onInteractOutside: ()=>{
            state?.close();
        },
        isDisabled: !state.isOpen || state.expandedKeysStack.length === 0
    });
    // On small screen devices, the menu is rendered in a tray, otherwise a popover.
    let overlay;
    if (isMobile) overlay = /*#__PURE__*/ (0, $3VWNT$react).createElement((0, $9fca089dca5508dc$export$4589ed81930b555c), {
        state: state,
        isFixedHeight: true,
        ref: rootOverlayRef
    }, menu);
    else overlay = /*#__PURE__*/ (0, $3VWNT$react).createElement((0, $3a473e3b7032f626$export$5b6b19405a83ff9d), {
        ref: rootOverlayRef,
        UNSAFE_style: {
            clipPath: 'unset',
            overflow: 'visible',
            filter: 'unset',
            borderWidth: '0px'
        },
        state: state,
        triggerRef: menuTriggerRef,
        scrollRef: menuRef,
        placement: initialPlacement,
        hideArrow: true,
        shouldFlip: shouldFlip,
        shouldContainFocus: true
    }, menu);
    return /*#__PURE__*/ (0, $3VWNT$react).createElement((0, $3VWNT$Fragment), null, /*#__PURE__*/ (0, $3VWNT$react).createElement((0, $62024859ff9f1f8a$export$8107b24b91795686), {
        slots: {
            actionButton: {
                holdAffordance: trigger === 'longPress'
            }
        }
    }, /*#__PURE__*/ (0, $3VWNT$react).createElement((0, $3VWNT$PressResponder), {
        ...menuTriggerProps,
        ref: menuTriggerRef,
        isPressed: state.isOpen
    }, menuTrigger)), /*#__PURE__*/ (0, $3VWNT$react).createElement((0, $9f4d05c8f96993f7$export$c7e742effb1c51e2).Provider, {
        value: menuContext
    }, overlay));
});


export {$9928637078ff3033$export$27d2ad3c5815583e as MenuTrigger};
//# sourceMappingURL=MenuTrigger.mjs.map
